exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".code-page{flex:1;display:flex;flex-flow:column;height:0}.code-page .page-toolbar{height:1px;background:#494c45;display:flex;flex-flow:row;justify-content:space-between;align-items:center}.code-page .page-content{flex:1;height:0;overflow:auto;display:block;border:1px solid #494c45}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-590aa198","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/shell/components/page/CodePage.vue
// module id = 303
// module chunks = 0